module.exports = __webpack_public_path__ + "static/media/6caed62d-eafd-4429-9006-cce6974ddeb2_1.8aad29975480bb28bef74efd4b6284b0.ad07c9a8.jpeg";